import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
export const abbreviatedPageId = (context: ExtendedContextStore) =>
  context.pageId === "Homepage,U,10" ? "HP" : context.pageId;
